module.exports = "<div class=\"browseZeroResults\">\r\n    <h1 class=\"browseZeroResults-header\">Sorry there aren’t any {{$ctrl.category.Description}} available.</h1>\r\n    <div class=\"browseZeroResults-blurb\" ng-if=\"$ctrl.category.IsSpecial\">\r\n        See what else is on <a ui-sref=\"shop.browse.department({department: 'specials'})\">special.</a>\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/browse/browse-zero-results.component.html
// module id = 121
// module chunks = 0 2